const REWARDS = {
    GOLD: {
        name: 'Gold',
        type: 'resources',
        category: 'currency',
    },
    CRYST: {
        name: 'Cryst',
        type: 'resources',
        category: 'currency',
    },
    HERO: {
        name: 'Hero',
        type: 'roster',
        category: 'unit',
    },
    WEAPON: {
        name: 'Weapon',
        type: 'inventory',
        category: 'weapon',
    },
    ARMOR: {
        name: 'Armor',
        type: 'inventory',
        category: 'armor',
    },
    SET: {
        name: 'Set Item',
        type: 'inventory',
        category: 'set',
    },
}

export default REWARDS
